import { PageLayout } from '@/layouts/page-layout'
import { List } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import { NavLink, Outlet, useLoaderData, useNavigate } from 'react-router-dom'
import { edit } from '@/router/utils'
import { useEffect } from 'react'

export const UserRoleList = () => {
  const { roles = [] } = useLoaderData()
  const { t } = useTranslation('translation', { keyPrefix: 'userRole' })
  const navigate = useNavigate()

  const availableRoles = roles.filter(role => role.name !== "admin").sort((a, b) => a.nameText.localeCompare(b.nameText))


  useEffect(() => {
    if (availableRoles.length) {
      navigate(edit('user_roles', availableRoles[0].id))
    }

  }, [])

  return (
    <PageLayout
      title={t('pages.list.title')}
    >
      <div className='grid grid-cols-12 gap-4'>
        <div className='col-span-3 border-r-2 h-full'>
          <List>
            {
              availableRoles.map((item) => (
                <NavLink key={item.id} to={edit('user_roles', item.id)} className=''>
                  {({ isActive }) => (
                    <div className={`text-black font-medium side-bar__link ${isActive ? 'bg-blue-100' : ''}`}>
                      {item.nameText}
                    </div>
                  )}
                </NavLink>
              ))
            }
          </List>
        </div>

        <div className='col-span-7'>
          <Outlet />
        </div>

      </div>

    </PageLayout>
  )
}
